import { render, staticRenderFns } from "./EditExaminer.vue?vue&type=template&id=938b10f6"
import script from "./EditExaminer.vue?vue&type=script&lang=js"
export * from "./EditExaminer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports